import { render, staticRenderFns } from "./PlanInfo.vue?vue&type=template&id=5667a54d&lang=pug"
import script from "./PlanInfo.vue?vue&type=script&lang=js"
export * from "./PlanInfo.vue?vue&type=script&lang=js"
import style0 from "./PlanInfo.vue?vue&type=style&index=0&id=5667a54d&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports